export { default as IndexTablePageHeader } from './IndexTablePageHeader';
